import React from 'react';
import './Pre.style.css';

const Pre = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const {
    children = null,
    size = 14,
    weight = 400,
    color = '#111111',
    style = {},
  } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <pre
      className="pre-components"
      style={{ fontSize: size, fontWeight: weight, color: color, ...style }}
    >
      {children}
    </pre>
  );
};
export default Pre;
